<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog"  width="500px" :destroy-on-close="true"  :before-close="cancel">
<!--    <div class="el-dialog-div">-->
      <el-form label-width="80px" ref="form" :model="form" :rules="rules">
        <el-form-item label="名称" prop="name">
          <el-input
              placeholder="请输入内容"
              v-model="form.name"
              clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="配置键" prop="confKey">
          <el-input
              type="textarea"
              :autosize="{ minRows: 3}"
              placeholder="请输入内容"
              v-model="form.confKey"
              clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="配置值" prop="confValue">
          <el-input
              type="textarea"
              :autosize="{ minRows: 3}"
              placeholder="请输入内容"
              v-model="form.confValue"
              clearable>
          </el-input>
        </el-form-item>
      </el-form>
<!--    </div>-->
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button size="small" type="primary" class="title" @click="handle">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {addConfig, editConfig} from "@/api/dilivery/sysconfig";

export default {
  name: "AddEditSysconfig",
  props:['showDialog','selectType','selectDetail'],
  data(){
    return{
      title:'',
      form:{
        name: '',
        confKey: '',
        confValue: ''
      },
      rules: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'change' }
        ],
        confKey: [
          { required: true, message: '配置键不能为空', trigger: 'change' }
        ],
      }
    }
  },
  mounted() {
  },
  watch: {
    'selectType':{
      handler(newVal){
        if (newVal){
          if(newVal.type==='edit'){
            this.title='编辑配置信息'
          }else {
            this.title='添加配置信息'
          }
        }
      },
      immediate:true
    },
    'selectDetail':{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.form.id = newVal.id
          this.form.name = newVal.name
          this.form.confKey = newVal.confKey
          this.form.confValue = newVal.confValue
        }
      },
      immediate:true
    },
  },
  methods: {
    cancel(){
      this.$emit('submit','cancel')
    },
    handle(){
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.selectType.type === 'add') {
            addConfig(this.form).then(res => {
              if (res.code === 200) {
                this.$emit('submit','confirm')
                this.$messageUi.success('添加成功')
              }
            }).catch(err => {
            })
          } else {
            editConfig(this.form).then(res => {
              if (res.code === 200) {
                this.$emit('submit','confirm')
                this.$messageUi.success('修改成功')
              }
            }).catch(err => {
            })
          }
        } else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
